import Component from '@ember/component';
import { action } from '@ember/object';

/*
  events
  - onFileSelected(file)
    - when a file is chosen
*/
export default Component.extend({
  onChange: action(function (e) {
    if (e.target.files.length === 1) {
      let file = e.target.files[0];
      this.onFileSelected(file);
    }
  }),
});
